<template>
  <div v-if="open" :class="rootClassName">
    <span v-if="$slots.icon" class="mr-4">
      <slot name="icon" />
    </span>

    <div class="flex-grow mr-4">
      <slot />

      <div v-if="$slots.actions" class="mt-4">
        <slot name="actions" />
      </div>
    </div>

    <IconButton @click="handleClose" class="-mr-1 -mt-1">
      <Icon name="times" class="text-primary" />
    </IconButton>
  </div>
</template>

<script>

import camelCase from 'lodash/camelCase'

import IconButton from '../IconButton'
import Icon from '../Icon'

export default {
  name: 'Toast',

  components: {
    Icon,
    IconButton
  },

  props: {
    open: Boolean,

    autoHideDuration: {
      type: Number,
      default: 2000
    },

    // type: {
    //   type: String,
    //   default: 'top-right',
    //   validator: v => [
    //     'success',
    //     'warning',
    //     'info',
    //     'error'
    //   ].includes(v)
    // },

    position: {
      type: String,
      default: 'top-right',
      validator: v => [
        'top-left',
        'top-center',
        'top-right',
        'bottom-left',
        'bottom-center',
        'bottom-right',
      ].includes(v)
    }
  },

  data: () => ({ autoHideTimeoutId: null }),

  watch: {
    open (nextOpen, currentOpen) {
      const isAboutToOpen = !currentOpen && nextOpen

      if (isAboutToOpen && this.autoHideDuration) {
        this.autoHideTimeoutId = setTimeout(
          this.handleClose.bind(this),
          this.autoHideDuration
        )
      }
    }
  },

  methods: {
    handleClose () {
      this.$emit('close')
      this.clearAutoHideTimeoutId()
    },

    clearAutoHideTimeoutId () {
      if (this.autoHideTimeoutId) {
        clearTimeout(this.autoHideTimeoutId)
      }
    }
  },

  computed: {
    rootClassName () {
      return [
        this.$style.root,
        this.$style[this.position]
      ]
    }
  }
}

</script>

<style module>

.root {
  --offset: 15px;

  position: fixed;
  display: flex;
  align-items: flex-start;
  z-index: 1001;

  @apply
    bg-white
    p-4
    rounded
    shadow-md;
}

.top-left {
  top: var(--offset);
  left: var(--offset);
}

.top-center {
  top: var(--offset);
  left: 50%;
  transform: translateX(-50%);
}

.top-right {
  top: var(--offset);
  right: var(--offset);
}

.bottom-left {
  bottom: var(--offset);
  left: var(--offset);
}

.bottom-center {
  bottom: var(--offset);
  left: 50%;
  transform: translateX(-50%);
}

.bottom-right {
  bottom: var(--offset);
  right: var(--offset);
}

</style>
